export default __webpack_public_path__ + "static/media/trello.6df8f3e5.svg";